'use strict';

module Patersons {
    export class ApproveChangeRequestCtrl extends TwoFactorAuthenticationCtrl {
        changeRequestService: ChangeRequestService;
        changeRequestId: number;

        static $inject = ['$scope', '$uibModalInstance', 'identityService', 'changeRequestService', 'changeRequestId'];

        constructor($scope, $uibModalInstance, identityService, changeRequestService, changeRequestId) {
            super($scope, $uibModalInstance, identityService)

            this.changeRequestService = changeRequestService;

            this.changeRequestId = changeRequestId;
        }

        submit() {
            this.scope.isSubmitted = true;

            if (this.scope.twoFactorAuthForm.$invalid) {
                return;
            }

            this.scope.isBusy = true;

            this.changeRequestService.approveChangeRequest(this.changeRequestId, this.scope.verificationCode)
                .then((result) => {
                    this.modalInstance.close(true);
                },
                (reason) => {
                    this.handleErrorResponse(reason);
                })
                .finally(() => {
                    this.scope.isBusy = false;
                });
        }
    }
}